import { apiClient } from "../api/apiClient.js";

const AGENTS_PATH = "/backoffice/agents";

/**
 * P156. Reads the employer applications submitted through an Agent's Employer
 * Invite Cards - GET /api/backoffice/agents/{agentId}/employer-applications.
 *
 * These rows are what makes "เมื่อ submit จะเข้ามาในผังเลยครับ" true: a company
 * that has filled in the Agent's form but has not been reviewed yet still
 * belongs on the Agent's Org Chart, exactly as a Quick Registered worker
 * application already does on the worker side. It is INTAKE, not an employer,
 * and every surface that shows it has to keep saying so.
 *
 * P139A wrote these rows from the public submit path and nothing ever read
 * them back; P156 added the read endpoint this calls.
 */
export function listEmployerApplications(agentId, { page = 1, pageSize = 50, search } = {}) {
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("pageSize", String(pageSize));
  if (search) {
    params.set("search", search);
  }

  return apiClient.get(`${AGENTS_PATH}/${encodeURIComponent(agentId)}/employer-applications?${params.toString()}`);
}
